import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL as API_BASE } from '../config/api';

const TermsOfServicePage = () => {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Terms of Service | Aureate Residences Ltd';
    window.scrollTo(0, 0);
    axios.get(`${API_BASE}/terms-of-service`)
      .then(r => { setTerms(r.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const fallbackSections = [
    {
      title: 'Acceptance of terms',
      content: 'By accessing and using this website, you accept and agree to be bound by these terms and conditions. If you do not agree, please do not use our website or services.'
    },
    {
      title: 'Services description',
      content: 'Aureate Residences Ltd provides accommodation solutions for organisations and property operations and management for property owners. Our services include:\n\n• Accommodation solutions — sourcing, providing and managing accommodation for corporate, temporary, supported and specialist requirements\n• Property operations and management — day-to-day operations, occupancy, maintenance coordination, contractor management and performance oversight\n• Landlord management solutions — full-service management for landlords and property owners, including overseas landlords\n\nThe specific terms of any accommodation or property arrangement will be set out in a separate written agreement.'
    },
    {
      title: 'User responsibilities',
      content: 'You agree to provide accurate and complete information when using our contact forms or services. You are responsible for maintaining the confidentiality of any account information and for all activities that occur under your account.'
    },
    {
      title: 'Intellectual property',
      content: 'All content on this website, including text, graphics, logos, images and software, is the property of Aureate Residences Ltd and is protected by copyright and other intellectual-property laws. You may not reproduce, distribute or create derivative works without our express written permission.'
    },
    {
      title: 'Limitation of liability',
      content: 'Aureate Residences Ltd shall not be liable for any indirect, incidental, special, consequential or punitive damages resulting from your use of, or inability to use, our services. Our liability is limited to the maximum extent permitted by law.'
    },
    {
      title: 'Third-party links',
      content: 'Our website may contain links to third-party websites. We are not responsible for the content or practices of those websites. Your use of third-party websites is at your own risk.'
    },
    {
      title: 'Modifications to terms',
      content: 'We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of our services after any changes indicates your acceptance of the new terms.'
    },
    {
      title: 'Governing law',
      content: 'These terms shall be governed by and construed in accordance with the laws of Scotland and the United Kingdom. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Scotland.'
    },
    {
      title: 'Contact information',
      content: 'If you have any questions about these Terms of Service, please contact us at info@aureate-resident.com or call +44 131 381 1989.'
    }
  ];

  const sections = (terms?.sections?.length > 0) ? terms.sections : fallbackSections;
  const lastUpdated = terms?.last_updated || new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

  if (loading) {
    return (
      <div style={{ background: 'var(--black)', minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 32, height: 32, border: '2px solid var(--gold)', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin-z 1s linear infinite' }} />
      </div>
    );
  }

  return (
    <div style={{ background: 'var(--black)' }}>
      {/* Hero */}
      <section className="approach" style={{ borderTop: 0, paddingBottom: 'clamp(40px, 5vw, 64px)' }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <div className="head" style={{ marginBottom: 0 }}>
            <span className="eyebrow">Legal</span>
            <h2>Terms of service.</h2>
            <p style={{ fontFamily: 'var(--mono)', fontSize: 12, letterSpacing: '.1em', color: 'var(--mute)' }}>
              Last updated: {lastUpdated}
            </p>
            <p>
              {terms?.introduction || 'Welcome to Aureate Residences. These Terms of Service govern your use of our website and services. Please read them carefully.'}
            </p>
          </div>
        </div>
      </section>

      {/* Sections */}
      <section style={{ paddingBlock: '0 clamp(80px, 11vw, 140px)' }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 48 }}>
            {sections.map((section, i) => (
              <div key={i} style={{ borderLeft: '2px solid rgba(212,175,55,.3)', paddingLeft: 24 }}>
                <h3 style={{ fontFamily: 'var(--serif)', fontWeight: 500, fontSize: 'clamp(22px, 2.2vw, 28px)', lineHeight: 1.2, marginBottom: 12, color: 'var(--ink)' }}>
                  {i + 1}. {section.title}
                </h3>
                <p style={{ color: 'var(--soft)', fontSize: 16, lineHeight: 1.65, whiteSpace: 'pre-line' }}>
                  {section.content}
                </p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 64, paddingTop: 32, borderTop: '1px solid var(--line-soft)' }}>
            <p style={{ color: 'var(--mute)', fontSize: 14 }}>
              By using our services, you acknowledge that you have read, understood and agree to be bound by these Terms of Service.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfServicePage;
